import { useApiMutation } from 'utils/queryClient'

export const useRegenerateServerToken = (options = {}) =>
  useApiMutation('/account/regenerate_server_token', 'post', options)
